"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ReportDay = _interopRequireDefault(require("./ReportDay.vue"));
var _ReportMonth = _interopRequireDefault(require("./ReportMonth.vue"));
var _ReportWeek = _interopRequireDefault(require("./ReportWeek.vue"));
var OrderPage = /*#__PURE__*/function (_Vue) {
  function OrderPage() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabName", "day");
    (0, _defineProperty2.default)(_this, "date", "");
    (0, _defineProperty2.default)(_this, "week", "");
    return _this;
  }
  (0, _inherits2.default)(OrderPage, _Vue);
  return (0, _createClass2.default)(OrderPage, [{
    key: "handleLoadDay",
    value: function handleLoadDay(date) {
      this.tabName = "day";
      this.date = date;
    }
  }, {
    key: "handleLoadWeek",
    value: function handleLoadWeek(date) {
      this.tabName = "week";
      this.week = date;
    }
  }]);
}(_vuePropertyDecorator.Vue);
OrderPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ReportDay: _ReportDay.default,
    ReportWeek: _ReportWeek.default,
    ReportMonth: _ReportMonth.default
  }
})], OrderPage);
var _default = exports.default = OrderPage;